<div class="mb-2">
  <h6 class="mb-0 small text-uppercase fw-semibold text-secondary">Tender Comparison</h6>
</div>

<div class="d-flex flex-column gap-2">

  <div class="comparison-row prev d-flex align-items-center gap-2">
    <span class="badge text-bg-secondary tag">Previous</span>
    <span class="comparison-name flex-grow-1 text-truncate">{{previousTender?.name}}</span>
    <span class="comparison-date text-muted small">{{$safeNavigationMigration(previousTender?.dateContractStart) | date: 'MMM yyyy'}}</span>
    <span class="badge text-bg-light comparison-units">{{previousTender?.currency.code}} / {{previousTender?.units.code}}</span>
  </div>

  <div class="comparison-row current d-flex align-items-center gap-2">
    <span class="badge text-bg-primary tag">Current</span>
    <span class="comparison-name flex-grow-1 text-truncate fw-semibold">{{tender.name}}</span>
    <span class="comparison-date text-muted small">{{tender.dateContractStart | date: 'MMM yyyy'}}</span>
    <span class="badge text-bg-light comparison-units">{{tender.currency.code}} / {{tender.units.code}}</span>
  </div>

  <div class="comparison-row view">
    <label class="form-label small text-muted mb-2">Override base currency / unit</label>
    <div class="d-flex flex-column gap-2">
      <div class="input-group input-group-sm">
        <span class="input-group-text rate-label">Currency</span>
        <jft-currency-select
          class="form-control p-0 border-0"
          [allowClear]="false"
          [currencyId]="baseCurrency.id"
          (onChangeCurrency)="baseCurrencyChange($event)">
        </jft-currency-select>
      </div>
      <div class="input-group input-group-sm">
        <span class="input-group-text rate-label">Unit</span>
        <jft-units-select
          class="form-control p-0 border-0"
          [allowClear]="false"
          (onChangeUnit)="baseUnitChange($event)"
          [unitId]="baseUnit.id">
        </jft-units-select>
      </div>
    </div>
  </div>

</div>
